import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import './index.css';
import App from './App';

Sentry.init({
  dsn: 'https://83aca51b1d01a26e294ebd8b85a956f1@o4511425410564096.ingest.us.sentry.io/4511425412005888',
  environment: process.env.NODE_ENV,
  tracesSampleRate: 0.2,
});

posthog.init('phc_s3d4BGxnZ8tKnmYXEyjm4m6fDYnCuQcErc4uUsZ5SN2p', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 32, color: '#fff' }}>Something went wrong. Reload the page.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
